<div class="container-fluid login-container login-bg">
  <img src="/assets/images/polygon_crop.png" class="img-fluid">
  <div class="row align-items-center login-container-row">
    <div class="col-md-6 title-block">
      One Stop Service for
      <div class="e-tax-title mt-2">E-TAX</div>
      <div class="e-tax-subtitle">Invoice & Receipt</div>
    </div>
    <div class="col-md-6">
      <div class="login-form">
        <div class="welcome-text mt-sm-4">Welcome Back</div>
        Please login to your account.

        <div class="form-group mt-4 mb-sm-2">
          <div class="form-label-group">
            <input class="form-control form-control-lg" id="username" name="username" placeholder="Username" type="text"
              [(ngModel)]="username" (keyup.enter)="login()">
            <label>Username</label>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label-group">
            <input class="form-control form-control-lg" id="password" name="password" placeholder="Password"
              type="password" [(ngModel)]="password" (keyup.enter)="login()">
            <label>Password</label>
          </div>
        </div>
        <div class="text-red text-center my-1 d-block">
          {{ errorMessage ? errorMessage : '&nbsp;' }}
        </div>

        <div class="form-group">
          <button class="btn btn-dv btn-wider" (click)="login()">
            Login
          </button>
        </div>

<!--        <div class="float-right">-->
<!--          <div class="footer-text">Powered by</div>-->
<!--           <img src="../../assets/images/logo.png" width="100">-->
<!--        </div>-->
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/login-admin/login-admin.component.html